<div class="h-screen w-screen flex overflow-hidden bg-white">
  <lohi-app-sidebar style="width: 320px !important"></lohi-app-sidebar>

  <main class="flex flex-col flex-1 h-screen overflow-y-auto">
    <router-outlet></router-outlet>
  </main>
</div>
